/**
 * Sprachschalter EN | GER.
 *
 * Zwei Sprachen, deshalb kein Auswahlfeld: beide Optionen stehen sichtbar
 * nebeneinander, eine Umschaltung kostet einen Klick statt zweier.
 *
 * Keine Flaggen. Eine Flagge steht fuer ein Land, nicht fuer eine Sprache --
 * und die Anwendung wird von Menschen in mehreren Laendern benutzt.
 *
 * Zugaenglichkeit: eine `radiogroup` aus zwei Schaltflaechen. Die aktive
 * Sprache traegt `aria-checked`, ist also nicht nur farblich erkennbar.
 * Jede Schaltflaeche traegt zusaetzlich `lang`, damit ein Vorlesewerkzeug
 * „English" englisch und „Deutsch" deutsch ausspricht.
 */
import { useI18n, type Language } from "../i18n/index.tsx";
import "./LanguageSwitch.css";

const OPTIONS: ReadonlyArray<{ lang: Language; label: string; hint: "language.toGerman" | "language.toEnglish" }> = [
  { lang: "en", label: "EN", hint: "language.toEnglish" },
  { lang: "de", label: "GER", hint: "language.toGerman" },
];

export function LanguageSwitch({ tone = "light" }: {
  /** `dark` fuer die Anmeldeseite, `light` fuer die Arbeitsoberflaeche. */
  tone?: "light" | "dark";
}): React.JSX.Element {
  const { lang, setLang, t } = useI18n();

  return (
    <div className={`langswitch langswitch--${tone}`} role="radiogroup" aria-label={t("language.label")}>
      {OPTIONS.map((o, i) => (
        <span key={o.lang}>
          {i > 0 && <span className="langswitch__sep" aria-hidden="true">|</span>}
          <button
            type="button"
            role="radio"
            lang={o.lang}
            aria-checked={lang === o.lang}
            className={lang === o.lang ? "langswitch__item langswitch__item--active" : "langswitch__item"}
            title={t(o.hint)}
            onClick={() => setLang(o.lang)}
          >
            {o.label}
          </button>
        </span>
      ))}
    </div>
  );
}
